import styled from 'styled-components';

import { PULSE, ANIM } from '../../../../theme/tokens';
import { Text } from '../../../../components';

/** Rank panel — tinted, NO border (Figma): "Rank / #14" left, "Top 28%" right. */
export const RankPanel = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  background: ${PULSE.panel};
  border-radius: 16px;
  padding: 12px;
`;

export const RankLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const RankLabel = styled(Text)`
  font-size: 16px;
  color: ${PULSE.t300};
`;

export const RankNum = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${PULSE.t50};
  line-height: 1.1;
`;

export const RankTop = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  color: ${PULSE.t50};
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

/** One comparison row — a tinted panel (NO border) with a label/value head and a
 *  You-vs-Median fill bar. */
export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${PULSE.panel};
  border-radius: 16px;
  padding: 12px;
`;

export const RowHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
`;

export const RowLabel = styled(Text)`
  font-size: 16px;
  color: ${PULSE.t300};
`;

export const RowVals = styled.span`
  font-size: 14px;
  font-weight: 300;
  color: ${PULSE.t300};
  white-space: nowrap;
`;

export const RowStrong = styled.b`
  font-weight: 300;
`;

export const Bar = styled.div`
  position: relative;
  height: 8px;
  border-radius: 100px;
  overflow: hidden;
  background: ${PULSE.netTrack};
`;

export const BarFill = styled.span<{ $color: string; $width: number }>`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 100px;
  border-right: 1px solid #000;
  width: ${(p) => p.$width}%;
  background: ${(p) => p.$color};
  transition: width ${ANIM.PULSE_BAR_ENTER_MS}ms ${PULSE.ease};
`;

/** Muted placeholder for the whole comparison — there is no cross-brand benchmark
 *  API yet, so the rank panel + You-vs-Median bars are replaced by this note. */
export const NotAvailable = styled(Text)`
  display: block;
  font-size: 14px;
  color: ${PULSE.t500};
  background: ${PULSE.panel};
  border-radius: 16px;
  padding: 16px;
`;
